import { useModalStack } from "hooks/useModalStack";
import { useAppDispatch, useAppSelector } from "hooks/useStore";
import {
  FilterDrawerSettings,
  setFilterDrawerSettings,
} from "store/slices/setting";

export const FILTER_DRAWER_MODAL_STACK_ID = "filter-drawer";

/**
 * @component useFilterDrawer
 * @description A hook used to open and close the filter sidebar using the modal stack. Can be passed a thread id and interaction, in which case the sidebar will apply fitlers to the interaction and resend instead of changing the global filters.
 */
function useFilterDrawer() {
  const dispatch = useAppDispatch();

  const { isModalOpen, openModal, closeModalIfTop } = useModalStack({
    id: FILTER_DRAWER_MODAL_STACK_ID,
    blocksScroll: true,
  });

  const filterDrawerSettings = useAppSelector(
    (state) => state.setting.filterDrawer
  );

  const openFilterDrawer = (filterDrawerSettings?: FilterDrawerSettings) => {
    dispatch(setFilterDrawerSettings(filterDrawerSettings ?? {}));
    openModal();
  };

  return {
    isFilterDrawerOpen: isModalOpen,
    openFilterDrawer: openFilterDrawer,
    closeFilterDrawer: closeModalIfTop,
    ...filterDrawerSettings,
  };
}

export default useFilterDrawer;
